function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { parseHeaderValueAsNumber } from "../util/helpers.js";
/**
 * The header that comes back from Azure services representing
 * the amount of time (minimum) to wait to retry (in seconds or timestamp after which we can retry).
 */

var RetryAfterHeader = "Retry-After";
/**
 * The headers that come back from Azure services representing
 * the amount of time (minimum) to wait to retry.
 *
 * "retry-after-ms", "x-ms-retry-after-ms" : milliseconds
 * "Retry-After" : seconds or timestamp
 */

var AllRetryAfterHeaders = ["retry-after-ms", "x-ms-retry-after-ms", RetryAfterHeader];
/**
 * A response is a throttling retry response if it has a throttling status code (429 or 503),
 * as long as one of the [ "Retry-After" or "retry-after-ms" or "x-ms-retry-after-ms" ] headers has a valid value.
 *
 * Returns the `retryAfterInMs` value if the response is a throttling retry response.
 * If not throttling retry response, returns `undefined`.
 *
 * @internal
 */

function getRetryAfterInMs(response) {
  if (!(response && [429, 503].includes(response.status))) return undefined;

  try {
    // Headers: "retry-after-ms", "x-ms-retry-after-ms", "Retry-After"
    var _iterator = _createForOfIteratorHelper(AllRetryAfterHeaders),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var header = _step.value;
        var retryAfterValue = parseHeaderValueAsNumber(response, header);

        if (retryAfterValue === 0 || retryAfterValue) {
          // "Retry-After" header ==> seconds
          // "retry-after-ms", "x-ms-retry-after-ms" headers ==> milli-seconds
          var multiplyingFactor = header === RetryAfterHeader ? 1000 : 1;
          return retryAfterValue * multiplyingFactor; // in milli-seconds
        }
      } // RetryAfterHeader ("Retry-After") has a special case where it might be formatted as a date instead of a number of seconds

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var retryAfterHeader = response.headers.get(RetryAfterHeader);
    if (!retryAfterHeader) return;
    var date = Date.parse(retryAfterHeader);
    var diff = date - Date.now(); // negative diff would mean a date in the past, so retry asap with 0 milliseconds

    return Number.isFinite(diff) ? Math.max(0, diff) : undefined;
  } catch (_a) {
    return undefined;
  }
}
/**
 * A response is a retry response if it has a throttling status code (429 or 503),
 * as long as one of the [ "Retry-After" or "retry-after-ms" or "x-ms-retry-after-ms" ] headers has a valid value.
 */


export function isThrottlingRetryResponse(response) {
  return Number.isFinite(getRetryAfterInMs(response));
}
export function throttlingRetryStrategy() {
  return {
    name: "throttlingRetryStrategy",
    retry: function retry(_ref) {
      var response = _ref.response;
      var retryAfterInMs = getRetryAfterInMs(response);

      if (!Number.isFinite(retryAfterInMs)) {
        return {
          skipStrategy: true
        };
      }

      return {
        retryAfterInMs: retryAfterInMs
      };
    }
  };
}